import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { confirm } from 'owa-confirm-dialog';
import clearSearchHistoryUserConfig from 'owa-privacy-option/lib/utils/clearSearchHistory';
import exportSearchHistoryUserConfig from 'owa-privacy-option/lib/utils/exportSearchHistory';

const styles = require('./PrivacyFull.scss');

export default class PrivacyFull extends React.Component<{}, {}> {
    render() {
        return (
            <div>
                <p>{strings.option_privacy_searchHistory_description}</p>
                <div className={styles.buttonContainer}>
                    <DefaultButton onClick={confirmAndClearSearchHistory} className={styles.button}>
                        {strings.option_privacy_searchHistory_delete}
                    </DefaultButton>
                    <DefaultButton
                        className={styles.button}
                        onClick={exportSearchHistoryUserConfig}>
                        {strings.option_privacy_searchHistory_export}
                    </DefaultButton>
                </div>
            </div>
        );
    }
}

function confirmAndClearSearchHistory(): void {
    let confirmationDialogPromise = confirm(
        strings.option_privacy_searchHistory_delete_confirmation_title,
        strings.option_privacy_searchHistory_delete_confirmation_description,
        false /*resolveImmediately*/,
        {
            okText: strings.option_privacy_searchHistory_delete_confirmation_continueButton,
            cancelText: strings.option_privacy_searchHistory_delete_confirmation_cancelButton,
        }
    );

    confirmationDialogPromise.then(clearSearchHistoryUserConfig);
}
